import type { PaletteOptions } from "@mui/material";

/**
 * Material 3 colour roles, expressed as MUI v6 palette options.
 * Dark (default) mirrors app.whitehatbots.com's deep-navy + mint identity.
 * Light keeps the same semantic roles but flips surfaces.
 */

export const darkPalette: PaletteOptions = {
  mode: "dark",
  primary: {
    main: "#26d39a",        // mint — positive, active, CTAs
    light: "#7ae9c2",
    dark: "#06a571",
    contrastText: "#003824"
  },
  secondary: {
    main: "#4da3ff",        // sky — secondary actions, line charts
    light: "#93c5ff",
    dark: "#1976d2",
    contrastText: "#00204d"
  },
  error: {
    main: "#ff5b5b",
    light: "#ff8a8a",
    dark: "#cc3838"
  },
  success: {
    main: "#26d39a",
    light: "#7ae9c2",
    dark: "#06a571"
  },
  warning: {
    main: "#ffb84d"
  },
  info: {
    main: "#4da3ff"
  },
  background: {
    default: "#0c1525",     // deep navy canvas
    paper:   "#11192a"      // surface-container-low — card default
  },
  text: {
    primary:   "#e8edf5",
    secondary: "#9aa6c0",
    disabled:  "#5a6680"
  },
  divider: "#2a3550",
  grey: {
    50:  "#f3f6fa",
    100: "#e8edf5",
    200: "#cbd3e2",
    300: "#9aa6c0",
    400: "#6f7d99",
    500: "#4a5670",
    600: "#2a3550",
    700: "#1c2a47",
    800: "#16213a",
    900: "#0c1525"
  },
  action: {
    active:           "#e8edf5",
    hover:            "rgba(38, 211, 154, 0.08)",
    hoverOpacity:     0.08,
    selected:         "rgba(38, 211, 154, 0.16)",
    selectedOpacity:  0.16,
    disabled:         "#5a6680",
    disabledBackground: "#1c2a47",
    focus:            "rgba(38, 211, 154, 0.24)"
  }
};

export const lightPalette: PaletteOptions = {
  mode: "light",
  primary: {
    main: "#00a878",
    light: "#4ecbaa",
    dark: "#007a55",
    contrastText: "#ffffff"
  },
  secondary: {
    main: "#1976d2",
    light: "#4da3ff",
    dark: "#0d47a1",
    contrastText: "#ffffff"
  },
  error: {
    main: "#d4423a"
  },
  success: {
    main: "#00a878"
  },
  warning: {
    main: "#e59100"
  },
  info: {
    main: "#1976d2"
  },
  background: {
    default: "#f5f7fb",
    paper:   "#ffffff"
  },
  text: {
    primary:   "#0c1525",
    secondary: "#4a5670",
    disabled:  "#9aa6c0"
  },
  divider: "#e1e6ef"
};

/** Colour constants used in charts and gradients that sit outside MUI palette. */
export const chartColors = {
  primary:    "#26d39a",
  primaryDim: "rgba(38, 211, 154, 0.18)",
  negative:   "#ff5b5b",
  negativeDim:"rgba(255, 91, 91, 0.18)",
  grid:       "rgba(42, 53, 80, 0.5)"
};
